module.exports = __webpack_public_path__ + "static/media/soundAttemptionNew.bfaa43be.mp3";